// eslint-disable-next-line
import { getRouters } from '@/api/menu'
import { indexRouterMap } from '@/config/router.config'
import allIcon from '@/core/icons'
import { validURL } from '@/utils/validate'
import { UserLayout, BlankLayout, PageView } from '@/layouts'
import auth from '@/plugins/auth'
// 前端路由表
const constantRouterComponents = {
  // 基础页面 layout 必须引入
  BasicLayout: () => import('@/layouts/BasicLayout'),
  BlankLayout: BlankLayout,
  RouteView: () => import('@/layouts/RouteView'),
  PageView: PageView,
  UserLayout: UserLayout, // 登陆注册页面的通用布局

  // 你需要动态引入的页面组件
  'Index': () => import('@/views/index'),
  // account
  'AccountCenter': () => import('@/views/account/center'),
  'AccountSettings': () => import('@/views/account/settings'),
  // 授权用户
  'AuthUser': () => import('@/views/system/role/authUser'),
  // 公告新增修改
  'NoticeForm': () => import('@/views/system/notice/modules/CreateForm'),
  //
  'zrIndex': () => import('@/views/sms/channel/zrdata'),
  // 修改生成配置
  'GenEdit': () => import('@/views/tool/gen/modules/GenEdit'),
  // ERP 业务页面
  'ErpCustomer': () => import('@/views/erp/customer/index'),
  'ErpCrmLead': () => import('@/views/erp/crm/lead/index'),
  'ErpCrmFollowUp': () => import('@/views/erp/crm/followUp/index'),
  'ErpCrmReminder': () => import('@/views/erp/crm/reminder/index'),
  'ErpCrmPublicPool': () => import('@/views/erp/crm/publicPool/index'),
  'ErpCrmPoolConfig': () => import('@/views/erp/crm/poolConfig/index'),
  'ErpProduct': () => import('@/views/erp/product/index'),
  'ErpSalesOrder': () => import('@/views/erp/sales/order/index'),
  'ErpSalesOutbound': () => import('@/views/erp/sales/outbound/index'),
  'ErpSalesAllowanceV2': () => import(/* webpackChunkName: "erp-sales-allowance-v2" */ '@/views/erp/sales/allowance/index.vue'),
  'ErpDeliveryWavePick': () => import(/* webpackChunkName: "erp-delivery-wave-pick" */ '@/views/erp/delivery/wave-pick/index.vue'),
  'ErpDeliveryTask': () => import(/* webpackChunkName: "erp-delivery-task" */ '@/views/erp/delivery/task/index.vue'),
  'ErpDeliveryRoute': () => import(/* webpackChunkName: "erp-delivery-route" */ '@/views/erp/delivery/route/index.vue'),
  'ErpDeliverySign': () => import(/* webpackChunkName: "erp-delivery-sign" */ '@/views/erp/delivery/sign/index.vue'),
  'ErpSupplier': () => import(/* webpackChunkName: "erp-supplier" */ '@/views/erp/supplier/index.vue'), // 供应商档案
  'ErpPurchaseOrder': () => import(/* webpackChunkName: "erp-purchase-order-v2" */ '@/views/erp/purchase/order/index.vue'),
  'ErpPurchaseInbound': () => import('@/views/erp/purchase/inbound/index'),
  'ErpStockOpening': () => import('@/views/erp/stock/opening/index'),
  'ErpOtherStockIn': () => import('@/views/erp/stock/other/inbound/index'),
  'ErpOtherStockOut': () => import('@/views/erp/stock/other/outbound/index'),
  'ErpStocktake': () => import(/* webpackChunkName: "erp-stocktake" */ '@/views/erp/stock/stocktake/index.vue'),
  'ErpStockProfit': () => import(/* webpackChunkName: "erp-stock-profit" */ '@/views/erp/stock/profit/index.vue'),
  'ErpStockLoss': () => import(/* webpackChunkName: "erp-stock-loss" */ '@/views/erp/stock/loss/index.vue'),
  'ErpFinanceReconciliation': () => import('@/views/erp/finance/reconciliation/index'),
  'ErpFinanceReceipt': () => import('@/views/erp/finance/receipt/index'),
  'ErpFinancePayment': () => import('@/views/erp/finance/payment/index'),
  'ErpFinancePaymentFlow': () => import('@/views/erp/finance/flow/index'),
  'ErpWarehouse': () => import('@/views/erp/warehouse/index'),
  'ErpPriceSystem': () => import('@/views/erp/product/priceSystem/index'),
  'ErpGuidePrice': () => import('@/views/erp/product/guidePrice/index'),
  'ErpStockLedger': () => import('@/views/erp/stock/ledger/index'),
  'ErpStockFlow': () => import('@/views/erp/stock/flow/index'),
  'ErpBasicSettings': () => import('@/views/system/basicSettings/index'),
  'ErpArea': () => import(/* webpackChunkName: "erp-area" */ '@/views/erp/area/index.vue'),
  'ErpOperationRule': () => import(/* webpackChunkName: "erp-operation-rule" */ '@/views/erp/operationRule/index.vue'),
  'ErpFreightRule': () => import(/* webpackChunkName: "erp-freight-rule" */ '@/views/erp/freightRule/index.vue'),
  'ErpDeliveryLine': () => import(/* webpackChunkName: "erp-delivery-line" */ '@/views/erp/deliveryLine/index.vue'),
  'ErpOpenApiMonitor': () => import(/* webpackChunkName: "erp-open-api-monitor" */ '@/views/erp/openApiMonitor/index.vue')
}

// 前端未找到页面路由（固定不用改）
const notFoundRouter = {
  path: '*', redirect: '/404', hidden: true
}

// 根级菜单
const rootMenu = {
  key: '',
  name: 'index',
  path: '',
  component: 'BasicLayout',
  redirect: '/index',
  meta: {
    title: '首页'
  },
  children: []
}

// 根级路由
const rootRouter = {
  key: '',
  name: 'index',
  path: '',
  component: constantRouterComponents.BasicLayout,
  redirect: '/index',
  meta: {
    title: '首页'
  },
  children: []
}

/**
 * 动态生成菜单
 * @param token
 * @returns {Promise<Router>}
 */
function collectMenuTitles (routes, out = new Set()) {
  ;(routes || []).forEach(route => {
    const title = route.meta && route.meta.title
    if (title) out.add(title)
    if (route.children && route.children.length) collectMenuTitles(route.children, out)
  })
  return out
}

/** 去掉与前端固定 ERP 菜单同名的后端菜单，避免 visible 修复后侧栏重复 */
function omitDuplicateBackendMenus (menus, titles) {
  return (menus || []).reduce((result, menu) => {
    const title = menu.meta && menu.meta.title
    if (title && titles.has(title)) return result
    const next = { ...menu }
    if (next.children && next.children.length) {
      next.children = omitDuplicateBackendMenus(next.children, titles)
      if (!next.children.length && next.component === 'RouteView') return result
    }
    result.push(next)
    return result
  }, [])
}

export const generatorDynamicRouter = (token) => {
  return new Promise((resolve, reject) => {
    // 向后端请求路由数据
    getRouters().then(res => {
      // 路由菜单分离，路由全部为二级，解决多级菜单缓存问题
      const routers = []
      const menuNav = []
      const asyncRoutes = filterDynamicRoutes(indexRouterMap)
      const frontendTitles = collectMenuTitles(asyncRoutes)
      const routerData = omitDuplicateBackendMenus(filterCurrentPhaseMenus(res.data || []), frontendTitles)
      rootMenu.children = asyncRoutes.concat(routerData)
      menuNav.push(rootMenu)
      const menus = generator(menuNav, null, routers)
      menus.push(notFoundRouter)
      // 同步注册路由端的兜底规则，避免直接访问未授权或不存在的地址时出现空白页。
      routers.push(notFoundRouter)
      rootRouter.children = routers
      // 必须返回数组，供 permission 里 router.addRoutes 使用
      resolve({ menus, routers: [rootRouter] })
    }).catch(err => {
      reject(err)
    })
  })
}

// 本期菜单只隐藏不在建设范围内的顶级业务板块，不删除后端权限和历史配置。
// 基础设置已由前端固定菜单放到独立一级目录，同时去掉后端返回的重复入口。
const CURRENT_PHASE_HIDDEN_ROOT_PATHS = ['app/user', 'yunying', 'pay']
const CURRENT_PHASE_HIDDEN_ROOT_TITLES = ['用户管理', '运营管理', '支付管理']

export function filterCurrentPhaseMenus (menus) {
  return menus.reduce((result, menu) => {
    const title = menu.meta && menu.meta.title
    if (CURRENT_PHASE_HIDDEN_ROOT_PATHS.includes(menu.path) || CURRENT_PHASE_HIDDEN_ROOT_TITLES.includes(title)) {
      return result
    }
    const nextMenu = { ...menu }
    if (nextMenu.children && nextMenu.children.length) {
      nextMenu.children = nextMenu.children
        .filter(child => child.component !== 'system/basicSettings/index')
        .map(child => ({ ...child }))
    }
    result.push(nextMenu)
    return result
  }, [])
}

function isSidebarVisibleRoute (route) {
  return !route.hidden && !(route.meta && route.meta.hidden)
}

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes (routes) {
  return routes.reduce((result, route) => {
    if (route.permissions && !auth.hasPermiOr(route.permissions)) return result
    if (route.roles && !auth.hasRoleOr(route.roles)) return result

    const nextRoute = { ...route }
    if (route.children && route.children.length) {
      nextRoute.children = filterDynamicRoutes(route.children)
      if (!nextRoute.children.length) return result
      // 侧栏无可展示子项时隐藏父级，但仍保留路由（深链/隐藏页）；避免空壳目录漏出
      const sidebarChildren = nextRoute.children.filter(isSidebarVisibleRoute)
      if (!sidebarChildren.length) {
        nextRoute.hidden = true
      } else {
        const visibleChildPaths = sidebarChildren.map(child => child.path)
        if (nextRoute.redirect && !visibleChildPaths.includes(nextRoute.redirect)) {
          nextRoute.redirect = sidebarChildren[0].path
        }
      }
    }
    result.push(nextRoute)
    return result
  }, [])
}

/**
 * 格式化树形结构数据 生成 vue-router 层级路由表
 *
 * @param routerMap
 * @param parent
 * @param routers
 * @returns {*}
 */
export const generator = (routerMap, parent, routers) => {
  const names = parent ? parent.meta.names : []
  return routerMap.map(item => {
    // 适配ruoyi一级菜单
    if (item.path === '/' && item.children && item.children.length === 1) {
      item = item.children[0]
      item.children = undefined
    }

    const { title, show, hideChildren, hiddenHeaderContent, hidden, icon, noCache } = item.meta || {}
    if (item.isFrame === 0) {
      item.target = '_blank'
    }
    const name = item.name || item.key || ''
    const isRouter = item.component && item.component !== 'Layout' && item.component !== 'ParentView'
    const currentRouter = {
      // 如果路由设置了 path，则作为默认 path，否则 路由地址 动态拼接生成如 /dashboard/workplace
      path: item.path || `${parent && parent.path || ''}/${item.path}`,
      // 路由名称，建议唯一
      name: name,
      // 该路由对应页面的 组件(动态加载)
      component: (constantRouterComponents[item.component || item.key]) || (() => import(`@/views/${item.component}`)),
      hidden: item.hidden,
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: {
        title: title,
        icon: allIcon[icon + 'Icon'] || icon,
        hiddenHeaderContent: hiddenHeaderContent,
        // 目前只能通过判断path的http链接来判断是否外链，适配若依
        target: validURL(item.path) ? '_blank' : '',
        permission: item.name,
        keepAlive: noCache === undefined ? false : !noCache,
        hidden: hidden,
        // 因菜单路由分离，通过此names确定菜单树的展开
        names: names.concat([name])
      },
      redirect: item.redirect
    }
    // 是否设置了隐藏菜单
    if (show === false) {
      currentRouter.hidden = true
    }
    // 适配若依，若依为缩写路径，而antdv-pro的pro-layout要求每个路径需为全路径
    if (!constantRouterComponents[item.component || item.key]) {
      // currentRouter.path = `${parent && parent.path !== '/' && parent.path || ''}/${item.path}`
      currentRouter.path = `${parent && parent.path !== '/' && parent.path + '/' || ''}${item.path}`
    }
    // 是否设置了隐藏子菜单
    if (hideChildren) {
      currentRouter.hideChildrenInMenu = true
    }
    // const names = parent.names
    const router = {
      path: currentRouter.path,
      // 路由名称，建议唯一
      name: currentRouter.name,
      // 该路由对应页面的 组件(动态加载)
      component: currentRouter.component,
      hidden: currentRouter.hidden,
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: currentRouter.meta,
      redirect: currentRouter.redirect
    }
    if (router.component && isRouter) {
      routers.push(router)
    }
    // 是否有子菜单，并递归处理，并将父path传入
    if (item.children && item.children.length > 0) {
      // Recursion
      currentRouter.children = generator(item.children, currentRouter, routers)
    }
    return currentRouter
  })
}
